<template>
    <div class="container">
      <DetailTemp :patientId="patientId" :patientUUID="patientUUID" :resumeCancelNum="resumeCancelNum" :orderNo="orderNo"></DetailTemp>
    </div>
</template>

<script>
  import DetailTemp from '@/components/doorHelp/DetailTemp'
    export default {
      data(){
        return {
          resumeCancelNum:this.$route.query.resumeCancelNum,
          patientId:this.$route.query.patientId,
          patientUUID:this.$route.query.patientUUID,
          orderNo:this.$route.query.orderNo
        }
      },
      components:{
        DetailTemp
      },
    }
</script>

<style scoped lang="scss">
  .container{
    background:#F8F8F8;
    position: relative;
    @include width_height_100();
  }
</style>



// WEBPACK FOOTER //
// src/views/doorHelp/applyDetail.vue